(function () {
    /* apply alternating layout to css */
    $('.ProductsAndCampaigns > ul > li:nth-child(even)').addClass('alternate');
})();